import script from "./indexKyts2.vue?vue&type=script&lang=js&setup=true"
export * from "./indexKyts2.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__